import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonPage,
  IonSpinner,
  IonToggle,
  IonTitle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import {
  ribbonOutline,
  starOutline,
  handRightOutline,
  shieldCheckmarkOutline,
  peopleOutline,
} from "ionicons/icons";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Fragment, useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router";

import { fraseMotivacional} from '../services/serviciosVarios'
import { Frase, CategoriaMensajeInicio } from "src/utils/interfaces";
import AgendaHomeCard from "src/components/AgendaHomeCard";

const CATEGORIA_CONFIG: Record<
  CategoriaMensajeInicio,
  { etiqueta: string; icono: string }
> = {
  valores_corporativos: { etiqueta: 'Valores corporativos', icono: ribbonOutline },
  calidad_servicio:     { etiqueta: 'Calidad de servicio',  icono: starOutline },
  etica_conducta:       { etiqueta: 'Ética y conducta',     icono: handRightOutline },
  politica:             { etiqueta: 'Política',             icono: shieldCheckmarkOutline },
  rse:                  { etiqueta: 'Responsabilidad social', icono: peopleOutline },
};

import Header from "src/components/Header";
// import CustomCarousel from "src/components/Carousel";
import { AlertActualizaDatos } from "src/components/AlertActualizaDatos";
import ActualizarDatosModal from "src/components/ActualizarDatosModal";
import BannerActivarNotificaciones from "src/components/BannerActivarNotificaciones";
import EventosInvitacionCard from "src/components/EventosInvitacionCard";
import EntregasRecepcionesCard from "src/components/EntregasRecepcionesCard";
import SolicitudesAprobarCard from "src/components/SolicitudesAprobarCard";
import CapacitacionesPendientesCard from "src/components/CapacitacionesPendientesCard";
import CapacitacionesPropuestasCard from "src/components/CapacitacionesPropuestasCard";
import AccionesCorrectivasCard from "src/components/AccionesCorrectivasCard";
import SolicitudesSstDevueltasCard from "src/components/SolicitudesSstDevueltasCard";
import MiDiaCard from "src/components/MiDiaCard";
import MiRutinaCard from "src/components/rutina/MiRutinaCard";
import MicroEncuestaCard from "src/components/MicroEncuestaCard";
import DatePicker from "src/components/DatePicker";
import { getEstadoPerfil } from "src/services/operarioPerfil"; // Estado desde backend
import OperariosRemplazos from "src/services/operarioRemplazo";
import Operarios from "src/services/operarios";
import LoginAPI from "src/services/login";
import Storage from "src/services/storage";
import {
  AlertasLimpiezaGeneralResponse,
  obtenerDetalleAusencias,
  obtenerAlertasLimpiezaGeneral,
  obtenerEncuestasBajas,
  obtenerReclamosClientes,
  ReclamoClienteItem,
  EncuestaBajaItem,
  obtenerDetalleReclamos,
  obtenerDetalleSinA,
  obtenerDetalleVisitas,
  obtenerKpisInicio,
  KpisInicioResponse,
  obtenerOrdenesPendientes,
  decidirOrdenPendiente,
  OrdenPendienteItem,
  obtenerVacacionesInicio,
  VacacionesInicioResponse,
} from "src/services/inicioKpis";
import {
  fetchResumenMensual,
  LimpiezaFrecuenciaItem,
  LimpiezaResumenMensual,
} from "src/services/limpiezasProfundas.service";
import { fetchRangosPedidoPorUnidad, RangoPedido } from "src/services/PedidoDeProducto/pedido.producto.services";
import { IVisita } from "src/services/visitas";
import { RegistroHistorialAPI, RegistroReclamoAPI } from "src/utils/interfaces";
import { defaultFeatureSwitches, isDevCargo } from "src/config/featureSwitches";
import { esGerenteDeOperaciones } from "src/config/gerenteOperaciones";
import { cargoParaPedido } from "src/config/cargoPedido";
import { obtenerFeatureSwitches } from "src/services/featureSwitches";
import {
  UnidadNegocioMarcacion,
  obtenerUnidadesMarcacion,
  actualizarUnidadesMarcacion,
  sincronizarUnidadesMarcacion,
} from "src/services/marcacionesUnidades";
import {
  CargoOrganizacionItem,
  obtenerCargosOrganizacion,
  actualizarCargosOrganizacion,
} from "src/services/cargosOrganizacion";
import {
  obtenerEstadisticasRepro,
  EstadisticasRepro,
} from "src/services/relevamientoOperativo";



type EncuestaCategoria = "colaboradores" | "limpieza" | "equipos" | "productos" | "fiscal";

const ENCUESTA_CATEGORIAS: { key: EncuestaCategoria; label: string }[] = [
  { key: "colaboradores", label: "Colaboradores" },
  { key: "limpieza", label: "Calidad de la limpieza" },
  { key: "equipos", label: "Equipos y máquinas" },
  { key: "productos", label: "Productos e insumos" },
  { key: "fiscal", label: "Gestión del fiscal" },
];

const Home = () => {
  const [frase, setFrase] = useState<Frase>();

  const [present] = useIonToast();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true); 

  const [reasons, setReasons] = useState<string[]>([]);
  const [showAlert, setShowAlert] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [kpis, setKpis] = useState<KpisInicioResponse | null>(null);
  const [kpisLoading, setKpisLoading] = useState(false);
  const [kpisError, setKpisError] = useState(false);
  const [lpResumen, setLpResumen] = useState<LimpiezaResumenMensual | null>(null);
  const [lpResumenLoading, setLpResumenLoading] = useState(false);
  const [lpResumenError, setLpResumenError] = useState(false);
  const [showLpModal, setShowLpModal] = useState(false);
  const [showAlertasLimpiezaModal, setShowAlertasLimpiezaModal] = useState(false);
  const [showVisitasModal, setShowVisitasModal] = useState(false);
  const [showSinAModal, setShowSinAModal] = useState(false);
  const [showReclamosModal, setShowReclamosModal] = useState(false);
  const [showReclamosClientesModal, setShowReclamosClientesModal] = useState(false);
  const [reclamosClientes, setReclamosClientes] = useState<ReclamoClienteItem[]>([]);
  const [reclamosClientesLoading, setReclamosClientesLoading] = useState(false);
  const [reclamosClientesError, setReclamosClientesError] = useState(false);
  const [showEncuestasBajasModal, setShowEncuestasBajasModal] = useState(false);
  const [encuestasBajasDetalle, setEncuestasBajasDetalle] = useState<EncuestaBajaItem[]>([]);
  const [showAusenciasModal, setShowAusenciasModal] = useState(false);
  const [showVacacionesModal, setShowVacacionesModal] = useState(false);
  const [visitasDetalle, setVisitasDetalle] = useState<IVisita[]>([]);
  const [sinADetalle, setSinADetalle] = useState<RegistroHistorialAPI[]>([]);
  const [ausenciasDetalle, setAusenciasDetalle] = useState<Array<{ legajo?: string | number | null; operario?: string | null; ps_nombre?: string | null; ps_codigo?: string | null; fecha?: string | null; tipo_ausencia?: "asignacion" | "total"; hora_ent?: string | null; hora_sal?: string | null }>>([]);
  const [reclamosDetalle, setReclamosDetalle] = useState<RegistroReclamoAPI[]>([]);
  const [sinAFiltro, setSinAFiltro] = useState("");
  const [ausenciasFiltro, setAusenciasFiltro] = useState("");
  const [ausenciasDesde, setAusenciasDesde] = useState("");
  const [ausenciasHasta, setAusenciasHasta] = useState("");
  const [ausenciasHoyTotal, setAusenciasHoyTotal] = useState<number | null>(null);
  const [visitasDetalleLoading, setVisitasDetalleLoading] = useState(false);
  const [sinADetalleLoading, setSinADetalleLoading] = useState(false);
  const [ausenciasDetalleLoading, setAusenciasDetalleLoading] = useState(false);
  const [reclamosDetalleLoading, setReclamosDetalleLoading] = useState(false);
  const [encuestasBajasLoading, setEncuestasBajasLoading] = useState(false);
  const [vacacionesLoading, setVacacionesLoading] = useState(false);
  const [alertasLimpiezaLoading, setAlertasLimpiezaLoading] = useState(false);
  const [visitasDetalleError, setVisitasDetalleError] = useState(false);
  const [sinADetalleError, setSinADetalleError] = useState(false);
  const [ausenciasDetalleError, setAusenciasDetalleError] = useState(false);
  const [reclamosDetalleError, setReclamosDetalleError] = useState(false);
  const [encuestasBajasError, setEncuestasBajasError] = useState(false);
  const [vacacionesError, setVacacionesError] = useState(false);
  const [alertasLimpiezaError, setAlertasLimpiezaError] = useState(false);
  const [puedeVerKpis, setPuedeVerKpis] = useState(false);
  const [puedeVerAlertasLimpiezaJefe, setPuedeVerAlertasLimpiezaJefe] = useState(false);
  const [puedeVerKpisJefe, setPuedeVerKpisJefe] = useState(false);
  const [ordenesPendientes, setOrdenesPendientes] = useState<OrdenPendienteItem[]>([]);
  const [ordenesPendientesLoading, setOrdenesPendientesLoading] = useState(false);
  const [ordenesPendientesError, setOrdenesPendientesError] = useState(false);
  const [showOrdenesPendientesModal, setShowOrdenesPendientesModal] = useState(false);
  const [ordenDecidiendoId, setOrdenDecidiendoId] = useState<number | null>(null);
  const [pedidoDisponible, setPedidoDisponible] = useState(false);
  const [pedidoLoading, setPedidoLoading] = useState(false);
  const [pedidoRangoTexto, setPedidoRangoTexto] = useState("");
  const [pedidoRol, setPedidoRol] = useState<"fiscal" | "jefe" | "" >("");
  const [showGestionModal, setShowGestionModal] = useState(false);
  const [showGestionSelectorModal, setShowGestionSelectorModal] = useState(false);
  const [showMarcacionesModal, setShowMarcacionesModal] = useState(false);
  const [showCargosModal, setShowCargosModal] = useState(false);
  const [gestionSelectorItem, setGestionSelectorItem] = useState<RegistroHistorialAPI | null>(null);
  const [gestionItem, setGestionItem] = useState<RegistroHistorialAPI | null>(null);
  const [cargoUsuario, setCargoUsuario] = useState("");
  const [featureSwitches, setFeatureSwitches] = useState(defaultFeatureSwitches);
  const [featureSwitchesLoaded, setFeatureSwitchesLoaded] = useState(false);
  const [gestionReemplazante, setGestionReemplazante] = useState("");
  const [gestionPs, setGestionPs] = useState("");
  const [gestionFecha, setGestionFecha] = useState("");
  const [gestionHoraEntrada, setGestionHoraEntrada] = useState("");
  const [gestionHoraSalida, setGestionHoraSalida] = useState("");
  const [gestionFechaAusencia, setGestionFechaAusencia] = useState("");
  const [gestionReemplazado, setGestionReemplazado] = useState<string | null>(null);
  const [gestionMotivo, setGestionMotivo] = useState("");
  const [gestionCupo, setGestionCupo] = useState("00:00");
  const [gestionCupoLoading, setGestionCupoLoading] = useState(false);
  const [gestionCupoError, setGestionCupoError] = useState("");
  const [gestionOperarios, setGestionOperarios] = useState<string[]>([]);
  const [gestionAsignacionesIds, setGestionAsignacionesIds] = useState<number[]>([]);
  const [gestionSaving, setGestionSaving] = useState(false);
  const [gestionSaveError, setGestionSaveError] = useState("");
  const [cedulaUsuario, setCedulaUsuario] = useState("");
  const [unidadesMarcacion, setUnidadesMarcacion] = useState<UnidadNegocioMarcacion[]>([]);
  const [unidadesMarcacionLoading, setUnidadesMarcacionLoading] = useState(false);
  const [unidadesMarcacionSaving, setUnidadesMarcacionSaving] = useState(false);
  const [unidadesMarcacionSyncing, setUnidadesMarcacionSyncing] = useState(false);
  const [unidadesMarcacionError, setUnidadesMarcacionError] = useState("");
  const [cargosOrganizacion, setCargosOrganizacion] = useState<CargoOrganizacionItem[]>([]);
  const [cargosOrganizacionLoading, setCargosOrganizacionLoading] = useState(false);
  const [cargosOrganizacionSaving, setCargosOrganizacionSaving] = useState(false);
  const [cargosOrganizacionError, setCargosOrganizacionError] = useState("");
  const [encuestasBajas, setEncuestasBajas] = useState<{
    limpieza: number;
    colaboradores: number;
    equipos: number;
    productos: number;
    fiscal: number;
  } | null>(null);
  const [vacaciones, setVacaciones] = useState<VacacionesInicioResponse | null>(null);
  const [alertasLimpieza, setAlertasLimpieza] = useState<AlertasLimpiezaGeneralResponse | null>(null);
  const [vacacionesEstadoFiltro, setVacacionesEstadoFiltro] = useState<"por_vencer" | "al_dia" | "vencido">("por_vencer");
  // Card Repro: progreso del fiscal sobre PS asignados
  const [statsRepro, setStatsRepro] = useState<EstadisticasRepro | null>(null);


  useEffect(() => {
    cargarFrase();
    evaluarPerfil();
    cargarPermisosKpis();
    cargarFeatureSwitches();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cargarFrase = () => {
    fraseMotivacional().then(
      (response) => {
        if (response) {
          setFrase(response.frase);
          setIsLoading(false);
        }
      },
      () => {
        present({
          message: "Ocurrió un error al cargar la frase",
          duration: 5000,
        });
      }
    );
  };

  const fechaHoyIso = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };


  const cargarKpis = async () => {
    setKpisLoading(true);
    setKpisError(false);
    try {
      const data = await obtenerKpisInicio(fechaHoyIso());
      setKpis(data);
    } catch (e) {
      setKpisError(true);
    } finally {
      setKpisLoading(false);
    }
  };

  const cargarResumenLp = async () => {
    setLpResumenLoading(true);
    setLpResumenError(false);
    try {
      const now = new Date();
      const data = await fetchResumenMensual({
        mes: now.getMonth() + 1,
        anio: now.getFullYear(),
      });
      setLpResumen(data ?? null);
    } catch {
      setLpResumen(null);
      setLpResumenError(true);
    } finally {
      setLpResumenLoading(false);
    }
  };

  const cargarAusenciasHoyTotal = async () => {
    try {
      const data = await obtenerDetalleAusencias(fechaHoyIso());
      setAusenciasHoyTotal(Array.isArray(data) ? data.length : 0);
    } catch {
      setAusenciasHoyTotal(null);
    }
  };

  const cargarFeatureSwitches = async () => {
    try {
      const data = await obtenerFeatureSwitches();
      setFeatureSwitches(data);
      setFeatureSwitchesLoaded(true);
    } catch {
      setFeatureSwitches(defaultFeatureSwitches);
      setFeatureSwitchesLoaded(true);
    }
  };

  const cargarPermisosKpis = async () => {
    try {
      const response = await LoginAPI.me();
      const cargo = response?.data?.datos?.emp_cargo || "";
      const cedula = response?.data?.datos?.emp_cedula || "";
      setCargoUsuario(cargo);
      setCedulaUsuario(String(cedula || ""));
      const cargoNorm = cargo.toLowerCase();
      const esFiscal = cargoNorm.includes("fiscal");
      // La gerente de Operaciones ve las tarjetas de jefe con toda la estructura.
      const esJefeOperaciones =
        cargoNorm.includes("jefe de operaciones") || cargoNorm.includes("jefe de ope")
        || esGerenteDeOperaciones(cargo);
      const esDev = isDevCargo(cargo);
      setPuedeVerKpis(esFiscal);
      setPuedeVerAlertasLimpiezaJefe(esJefeOperaciones);
      setPuedeVerKpisJefe(esJefeOperaciones);
      evaluarDisponibilidadPedidos(cargoParaPedido(cargo));
    } catch {
      setPuedeVerKpis(false);
      setPuedeVerAlertasLimpiezaJefe(false);
      setPuedeVerKpisJefe(false);
      setPedidoDisponible(false);
    }
  };

  useEffect(() => {
    if (puedeVerKpis && featureSwitchesLoaded && featureSwitches.homeKpis) {
      cargarKpis();
      cargarResumenLp();
      cargarAusenciasHoyTotal();
      cargarEncuestasBajas();
      cargarReclamosClientes();
      cargarVacaciones();
    }
    // Card Repro: oculta de momento (Repro ya no se está usando).
    // if (puedeVerKpis) {
    //   obtenerEstadisticasRepro()
    //     .then((data) => setStatsRepro(data))
    //     .catch(() => setStatsRepro(null));
    // }
  }, [puedeVerKpis, featureSwitchesLoaded, featureSwitches.homeKpis]);

  useEffect(() => {
    if (puedeVerKpisJefe && featureSwitchesLoaded && featureSwitches.homeKpis) {
      cargarEncuestasBajas();
      cargarReclamosClientes();
      cargarDetalleReclamos();
      cargarOrdenesPendientes();
    }
  }, [puedeVerKpisJefe, featureSwitchesLoaded, featureSwitches.homeKpis]);

  useEffect(() => {
    if (puedeVerAlertasLimpiezaJefe) {
      cargarAlertasLimpiezaGeneral();
    }
  }, [puedeVerAlertasLimpiezaJefe]);

  useEffect(() => {
    if (showSinAModal) {
      cargarFeatureSwitches();
    }
  }, [showSinAModal]);

  const evaluarDisponibilidadPedidos = async (cargo: string) => {
    setPedidoLoading(true);
    setPedidoDisponible(false);
    setPedidoRangoTexto("");
    setPedidoRol("");
    try {
      const cargoUpper = (cargo || "").toUpperCase();
      const esFiscal = cargoUpper.includes("FISCAL") || cargoUpper.includes("LIDER AGENTIS");
      const esJefe = cargoUpper.includes("JEFE") || cargoUpper.includes("GERENTE DE OPERACIONES");

      if (!esFiscal && !esJefe) return;

      // TD-11079: la ventana de pedidos es por unidad de negocio. Aca no hay un
      // punto de servicio en contexto, asi que el banner se muestra si alguna
      // unidad esta abierta e informa cuales.
      const rangos = await fetchRangosPedidoPorUnidad();
      if (!rangos || rangos.length === 0) return;

      const now = new Date();
      const abiertos: string[] = [];

      const estaAbierto = (rango: RangoPedido) => {
        const fechaInicio = esFiscal ? rango.fecha_inicio_fiscal : rango.fecha_inicio_jefe;
        const fechaFin = esFiscal ? rango.fecha_fin_fiscal : rango.fecha_fin_jefe;
        const horaInicio = esFiscal ? rango.hora_inicio_fiscal : rango.hora_inicio_jefe;
        const horaFin = esFiscal ? rango.hora_fin_fiscal : rango.hora_fin_jefe;

        if (!fechaInicio || !fechaFin) return null;

        const startDate = new Date(`${fechaInicio}T00:00:00`);
        const endDate = new Date(`${fechaFin}T23:59:59`);
        if (now < startDate || now > endDate) return null;

        const todayDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

        const [hfStartH, hfStartM, hfStartS] = (horaInicio || "00:00:00").split(":").map(Number);
        const [hfEndH, hfEndM, hfEndS] = (horaFin || "23:59:59").split(":").map(Number);
        const startTime = new Date();
        startTime.setHours(hfStartH || 0, hfStartM || 0, hfStartS || 0, 0);
        const endTime = new Date();
        endTime.setHours(hfEndH || 23, hfEndM || 59, hfEndS || 59, 999);

        if (todayDateOnly.getTime() === startDateOnly.getTime() && now < startTime) return null;
        if (todayDateOnly.getTime() === endDateOnly.getTime() && now > endTime) return null;

        const unidad = rango.unidad_negocio ? `${rango.unidad_negocio}: ` : "";
        return `${unidad}${fechaInicio} ${(horaInicio || "00:00").slice(0, 5)} - ${fechaFin} ${(horaFin || "23:59").slice(0, 5)}`;
      };

      rangos.forEach((rango) => {
        const texto = estaAbierto(rango);
        if (texto) abiertos.push(texto);
      });

      if (abiertos.length === 0) return;

      setPedidoDisponible(true);
      setPedidoRol(esFiscal ? "fiscal" : "jefe");
      setPedidoRangoTexto(abiertos.join(" | "));
    } catch {
      setPedidoDisponible(false);
    } finally {
      setPedidoLoading(false);
    }
  };

  const formatFecha = (value: any) => {
    if (!value) return "";
    if (value instanceof Date) return value.toLocaleDateString();
    const text = String(value);
    if (text.length >= 10) return text.slice(0, 10);
    return text;
  };

  const fechaIsoValue = (value: any) => {
    if (!value) return "";
    if (value instanceof Date) return value.toISOString().slice(0, 10);
    const text = String(value);
    if (text.length >= 10) return text.slice(0, 10);
    return text;
  };

  const formatHora = (value: any) => {
    if (!value) return "-";
    return String(value).slice(0, 5);
  };

  const normalizarHora = (value: any) => {
    if (!value) return "";
    const text = String(value);
    if (text.length >= 5) return text.slice(0, 5);
    return text;
  };

  const hhmmToMin = (value: string) => {
    try {
      const [h, m] = (value || "0:00").split(":").map((n) => parseInt(n, 10) || 0);
      return h * 60 + m;
    } catch {
      return 0;
    }
  };

  const minToHHmm = (min: number) => {
    const safe = Math.max(0, Math.floor(min || 0));
    const hh = String(Math.floor(safe / 60)).padStart(2, "0");
    const mm = String(safe % 60).padStart(2, "0");
    return `${hh}:${mm}`;
  };

  const normalizarTexto = (value: any) => {
    return String(value || "").toLowerCase().trim();
  };

  const LP_FRECUENCIAS_DEFAULT: LimpiezaFrecuenciaItem[] = [
    { key: "quincenal", label: "Quincenal" },
    { key: "mensual", label: "Mensual" },
    { key: "bimestral", label: "Bimestral" },
    { key: "trimestral", label: "Trimestral" },
    { key: "cuatrimestral", label: "Cuatrimental" },
    { key: "semestral", label: "Semestral" },
    { key: "anual", label: "Anual" },
  ];

  const lpFrecuencias = (lpResumen?.frecuencias?.length
    ? lpResumen.frecuencias.filter((item) => item.key !== "otros")
    : LP_FRECUENCIAS_DEFAULT
  ).map((item) => ({
    ...item,
    total: lpResumen?.resumen?.por_frecuencia?.[item.key] ?? 0,
  }));

  const lpMaxFrecuencia = Math.max(
    1,
    ...lpFrecuencias.map((item) => item.total || 0)
  );

  const lpPuntosConLp = (lpResumen?.puntos_servicio || []).filter(
    (ps) => (ps.total ?? 0) > 0
  );

  const formatearMesLp = (mes?: number, anio?: number, fallback?: string) => {
    if (!mes || !anio) return fallback || "Mes";
    const fecha = new Date(anio, mes - 1, 1);
    const texto = new Intl.DateTimeFormat("es-ES", {
      month: "long",
      year: "numeric",
    }).format(fecha);
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  };

  const lpEtiquetaMes = formatearMesLp(
    lpResumen?.calendario?.mes,
    lpResumen?.calendario?.anio,
    lpResumen?.calendario?.etiqueta
  );

  const abrirLpDesdeModal = (ps: { ps_id?: number; ps_codigo?: string; ps_nombre?: string }) => {
    if (!ps.ps_id || !ps.ps_codigo || !ps.ps_nombre) return;
    sessionStorage.setItem("lp_ps_id", String(ps.ps_id));
    sessionStorage.setItem("lp_ps_codigo", ps.ps_codigo);
    sessionStorage.setItem("lp_ps_nombre", ps.ps_nombre);
    setShowLpModal(false);
    history.push("/limpiezas-profundas");
  };

  const filtrarPorPs = <T,>(
    lista: T[],
    filtro: string,
    getPs: (item: T) => string
  ) => {
    const q = normalizarTexto(filtro);
    if (q.length < 3) return lista;
    return (lista || []).filter((item) => normalizarTexto(getPs(item)).includes(q));
  };

  const getOperarioNombre = (item: any) => {
    return (
      item?.op_nombre ||
      item?.operario ||
      item?.nombreOperario ||
      item?.nombre ||
      item?.operario_nombre ||
      ""
    );
  };

  const getOperarioLegajo = (item: any) => {
    return (
      item?.legajo ||
      item?.op_legajo ||
      item?.nroLegajo ||
      item?.operario_legajo ||
      item?.legajoOperario ||
      ""
    );
  };

  const ordenarVacaciones = (lista: VacacionesInicioResponse["datos"] = []) => {
    return [...lista].sort((a, b) => {
      const prioridad = (item: VacacionesInicioResponse["datos"][number]) => {
        if (item.proximo) return 0;
        if (item.vencido) return 1;
        return 2;
      };

      const prioridadA = prioridad(a);
      const prioridadB = prioridad(b);
      if (prioridadA !== prioridadB) {
        return prioridadA - prioridadB;
      }

      if (a.proximo && b.proximo) {
        return (a.dias_faltantes ?? 999) - (b.dias_faltantes ?? 999);
      }

      if (a.vencido && b.vencido) {
        return b.saldos_pendientes_anteriores - a.saldos_pendientes_anteriores;
      }

      return a.nombre_empleado.localeCompare(b.nombre_empleado);
    });
  };

  const filtrarVacacionesPorEstado = (
    lista: VacacionesInicioResponse["datos"] = [],
    filtro: "por_vencer" | "al_dia" | "vencido"
  ) => {
    return lista.filter((item) => {
      if (filtro === "por_vencer") return item.proximo;
      if (filtro === "vencido") return item.vencido;
      return !item.proximo && !item.vencido;
    });
  };

  const motivosReemplazo = [
    { value: "Accidente", label: "Accidente" },
    { value: "Enfermedad", label: "Enfermedad" },
    { value: "Transporte", label: "Transporte" },
    { value: "Asalto", label: "Asalto" },
    { value: "Permiso", label: "Permiso" },
    { value: "Duelo", label: "Duelo" },
    { value: "Renuncia", label: "Renuncia" },
    { value: "Vacaciones", label: "Vacaciones" },
    { value: "Suspendido", label: "Suspendido" },
    { value: "CambioLibre", label: "Cambio Día Libre" },
    { value: "noContesta", label: "No contesta" },
    { value: "NoAceptaAsignacion", label: "No acepta asignación" },
    { value: "consultaMedica", label: "Consulta Médica" },
    { value: "reposoMedico", label: "Reposo Médico" },
    { value: "eventoFamiliar", label: "Eventos Familiares" },
    { value: "gestionesParticulares", label: "Gestiones Particulares" },
    { value: "Viajes", label: "Viajes" },
    { value: "gestionAutomatica", label: "Gestión Automática" },
    { value: "controlMarcacion", label: "Control de marcación" },
    { value: "Otros", label: "Otros" },
  ];

  const cargarOperariosGestion = async () => {
    if (gestionOperarios.length > 0) return;
    try {
      const lista = await Operarios.listarOperarios();
      const datos = Array.isArray(lista)
        ? lista.map((o: any) => `${o.nombre} - ${o.legajo}`)
        : [];
      setGestionOperarios(datos);
    } catch {
      setGestionOperarios([]);
    }
  };

  const abrirSelectorGestion = (item: RegistroHistorialAPI) => {
    setGestionSelectorItem(item);
    setShowGestionSelectorModal(true);
  };

  const cerrarSelectorGestion = () => {
    setShowGestionSelectorModal(false);
    setGestionSelectorItem(null);
  };

  const resolverPsId = async (psNombre?: string | null, psCodigo?: string | null) => {
    try {
      const filtro = (psNombre || psCodigo || "").trim();
      if (!filtro) return null;
      const res = await OperariosRemplazos.listar(filtro);
      const lista = res?.data?.datos || res?.data || [];
      const data = Array.isArray(lista) ? lista : [];
      const normalizar = (v: any) => String(v || "").toLowerCase().trim();
      const match = data.find((p: any) =>
        normalizar(p?.NombrePServicio || p?.ps_nombre) === normalizar(psNombre)
        || normalizar(p?.objeto || p?.ps_codigo) === normalizar(psCodigo)
      );
      const id = match?.id || match?.ps_id || match?.PuntoServicio_id;
      return id ? String(id) : null;
    } catch {
      return null;
    }
  };

  const abrirNuevaAsignacion = async (item: RegistroHistorialAPI) => {
    const nombre = getOperarioNombre(item);
    const legajo = getOperarioLegajo(item);
    const psNombre = item.ps_nombre || "";
    const psCodigo = item.ps_codigo || "";
    if (!nombre || !legajo) {
      present({ message: "El operario no tiene legajo válido.", duration: 4000, color: "warning" });
      return;
    }
    const psId = await resolverPsId(psNombre, psCodigo);
    if (!psId) {
      present({ message: "No se pudo resolver el PS para asignación.", duration: 4000, color: "warning" });
      return;
    }
    sessionStorage.setItem("ps_id", psId);
    sessionStorage.setItem("ps_nombre", psNombre);
    sessionStorage.setItem("op", nombre);
    sessionStorage.setItem("legajo", String(legajo));
    cerrarSelectorGestion();
    setShowSinAModal(false);
    history.push("/asignacionDetalle");
    present({ message: "Selecciona + ASIGNACION para continuar.", duration: 4000, color: "primary" });
  };

  const abrirGestionRapida = async (item: RegistroHistorialAPI) => {
    const nombre = getOperarioNombre(item);
    const legajo = getOperarioLegajo(item);
    const reemplazante = legajo ? `${nombre} - ${legajo}` : (nombre || "");
    const fecha = fechaIsoValue(item.fecha);
    setGestionItem(item);
    setGestionReemplazante(reemplazante);
    setGestionPs(item.ps_nombre || item.ps_codigo || "");
    setGestionFecha(fecha);
    setGestionHoraEntrada(normalizarHora(item.hora_entrada));
    setGestionHoraSalida(normalizarHora(item.hora_salida));
    setGestionFechaAusencia(fecha);
    setGestionReemplazado(null);
    setGestionMotivo("");
    setGestionCupo("00:00");
    setGestionCupoError("");
    setGestionAsignacionesIds([]);
    setGestionSaveError("");
    setShowGestionModal(true);
    await cargarOperariosGestion();
  };

  const cerrarGestionRapida = () => {
    setShowGestionModal(false);
    setGestionItem(null);
    setGestionSaveError("");
  };

  useEffect(() => {
    const cargarCupo = async () => {
      if (!showGestionModal) return;
      if (!gestionReemplazado || !gestionFechaAusencia || !gestionPs) {
        setGestionCupo("00:00");
        setGestionCupoError("");
        setGestionAsignacionesIds([]);
        return;
      }
      setGestionCupoLoading(true);
      setGestionCupoError("");
      try {
        const res = await OperariosRemplazos.listarOperariosRemplazo({
          remplazado: gestionReemplazado,
          fechaInicio: gestionFechaAusencia,
          fechaFin: gestionFechaAusencia,
        });
        const data = res?.data || [];
        const asignaciones = Array.isArray(data) ? data : [];
        const ids = asignaciones
          .filter((a: any) => (a?.NombrePServicio || "") === gestionPs)
          .map((a: any) => a?.id)
          .filter((id: any) => id !== null && id !== undefined);
        setGestionAsignacionesIds(ids);
        if (!ids.length) {
          setGestionCupo("00:00");
          setGestionCupoError("No hay asignaciones del ausente en este PS para la fecha.");
          return;
        }
        const cupoRes = await OperariosRemplazos.cupoPorDia({
          asignaciones_id: ids,
          fecha_inicio: gestionFechaAusencia,
          fecha_fin: gestionFechaAusencia,
          ps_nombre: gestionPs,
          remplazado: gestionReemplazado,
        });
        const dias = cupoRes?.data?.dias || cupoRes?.data || [];
        const dia = Array.isArray(dias)
          ? dias.find((d: any) => d.fecha === gestionFechaAusencia) || dias[0]
          : null;
        setGestionCupo(dia?.cupo_total || "00:00");
      } catch {
        setGestionCupo("00:00");
        setGestionAsignacionesIds([]);
        setGestionCupoError("No se pudo calcular el cupo.");
      } finally {
        setGestionCupoLoading(false);
      }
    };
    cargarCupo();
  }, [showGestionModal, gestionReemplazado, gestionFechaAusencia, gestionPs]);

  const guardarGestionRapida = async () => {
    if (gestionSaving) return;
    setGestionSaveError("");
    const reemplazante = gestionReemplazante || "";
    const reemplazado = gestionReemplazado || "";
    const fechaSinA = gestionFecha;
    const fechaAusencia = gestionFechaAusencia;
    const horaEnt = gestionHoraEntrada;
    const horaSal = gestionHoraSalida;
    if (!reemplazante || !reemplazante.includes(" - ")) {
      setGestionSaveError("El operario SIN-A no tiene legajo válido.");
      return;
    }
    if (!reemplazado || !reemplazado.includes(" - ")) {
      setGestionSaveError("Seleccioná el operario ausente.");
      return;
    }
    if (!gestionMotivo) {
      setGestionSaveError("Seleccioná un motivo.");
      return;
    }
    if (!gestionPs || !fechaSinA || !horaEnt || !horaSal) {
      setGestionSaveError("Completá los datos obligatorios.");
      return;
    }
    if (!gestionAsignacionesIds.length) {
      setGestionSaveError("No hay asignaciones disponibles para calcular cupo.");
      return;
    }
    const durMin = Math.max(0, hhmmToMin(horaSal) - hhmmToMin(horaEnt));
    if (durMin <= 0) {
      setGestionSaveError("El horario no es válido.");
      return;
    }
    if (hhmmToMin(gestionCupo) <= 0) {
      setGestionSaveError("El cupo disponible es 00:00.");
      return;
    }

    const payload: any = {
      remplazado: reemplazado,
      remplazante: reemplazante,
      fechaInicioRemplazante: fechaSinA,
      fechaFinRemplazante: fechaSinA,
      puntoServicio: gestionPs,
      horaEntradaRemplazante: horaEnt,
      horaSalidaRemplazante: horaSal,
      motivo: gestionMotivo,
      asignaciones_id: gestionAsignacionesIds,
      fechas: [fechaSinA],
    };

    if (fechaAusencia && fechaAusencia !== fechaSinA) {
      payload.modo = "COMPENSACION";
      payload.compensaciones = [
        {
          fechaOrigen: fechaAusencia,
          fechaDestino: fechaSinA,
          minutos: minToHHmm(durMin),
        },
      ];
    }

    try {
      setGestionSaving(true);
      const res = await OperariosRemplazos.cargarRemplazo([payload]);
      const msg = res?.data?.info || "Reemplazo creado.";
      present({ message: msg, duration: 5000, color: "success" });
      cerrarGestionRapida();
      cargarDetalleSinA();
    } catch (error: any) {
      const msg = error?.response?.data?.error || "No se pudo crear el reemplazo.";
      setGestionSaveError(msg);
    } finally {
      setGestionSaving(false);
    }
  };

  const cargarDetalleVisitas = async () => {
    setVisitasDetalleLoading(true);
    setVisitasDetalleError(false);
    try {
      const data = await obtenerDetalleVisitas(fechaHoyIso());
      setVisitasDetalle(data);
    } catch (e) {
      setVisitasDetalleError(true);
      setVisitasDetalle([]);
    } finally {
      setVisitasDetalleLoading(false);
    }
  };

  const cargarDetalleSinA = async () => {
    setSinADetalleLoading(true);
    setSinADetalleError(false);
    try {
      const data = await obtenerDetalleSinA(fechaHoyIso());
      const soloSinA = (data || []).filter((item) => String(item.tipo || "").toUpperCase() === "SIN-A");
      setSinADetalle(soloSinA);
    } catch (e) {
      setSinADetalleError(true);
      setSinADetalle([]);
    } finally {
      setSinADetalleLoading(false);
    }
  };

  const cargarDetalleReclamos = async () => {
    setReclamosDetalleLoading(true);
    setReclamosDetalleError(false);
    try {
      const data = await obtenerDetalleReclamos(fechaHoyIso());
      setReclamosDetalle(data || []);
    } catch (e) {
      setReclamosDetalleError(true);
      setReclamosDetalle([]);
    } finally {
      setReclamosDetalleLoading(false);
    }
  };

  const cargarReclamosClientes = async () => {
    setReclamosClientesLoading(true);
    setReclamosClientesError(false);
    try {
      const data = await obtenerReclamosClientes();
      setReclamosClientes(data?.datos || []);
    } catch {
      setReclamosClientesError(true);
      setReclamosClientes([]);
    } finally {
      setReclamosClientesLoading(false);
    }
  };

  const cargarEncuestasBajas = async () => {
    setEncuestasBajasLoading(true);
    setEncuestasBajasError(false);
    try {
      const data = await obtenerEncuestasBajas();
      setEncuestasBajas(data?.conteos || null);
      setEncuestasBajasDetalle(data?.datos || []);
    } catch {
      setEncuestasBajasError(true);
      setEncuestasBajas(null);
      setEncuestasBajasDetalle([]);
    } finally {
      setEncuestasBajasLoading(false);
    }
  };

  const cargarOrdenesPendientes = async () => {
    setOrdenesPendientesLoading(true);
    setOrdenesPendientesError(false);
    try {
      const data = await obtenerOrdenesPendientes();
      setOrdenesPendientes(data?.datos || []);
    } catch {
      setOrdenesPendientesError(true);
      setOrdenesPendientes([]);
    } finally {
      setOrdenesPendientesLoading(false);
    }
  };

  const decidirOrden = async (
    ordenId: number | null,
    accion: "aprobar" | "rechazar"
  ) => {
    if (!ordenId || ordenDecidiendoId !== null) return;
    setOrdenDecidiendoId(ordenId);
    try {
      await decidirOrdenPendiente(ordenId, accion);
      setOrdenesPendientes((prev) => prev.filter((item) => item.id !== ordenId));
      present({
        message:
          accion === "aprobar"
            ? "Orden aprobada correctamente"
            : "Orden rechazada correctamente",
        duration: 2500,
      });
    } catch (err: any) {
      present({
        message:
          err?.response?.data?.error ||
          (accion === "aprobar"
            ? "No se pudo aprobar la orden"
            : "No se pudo rechazar la orden"),
        duration: 3500,
      });
    } finally {
      setOrdenDecidiendoId(null);
    }
  };

  const cargarVacaciones = async () => {
    setVacacionesLoading(true);
    setVacacionesError(false);
    try {
      const data = await obtenerVacacionesInicio(45);
      setVacaciones(data);
    } catch {
      setVacacionesError(true);
      setVacaciones(null);
    } finally {
      setVacacionesLoading(false);
    }
  };

  const cargarAlertasLimpiezaGeneral = async () => {
    setAlertasLimpiezaLoading(true);
    setAlertasLimpiezaError(false);
    try {
      const data = await obtenerAlertasLimpiezaGeneral();
      setAlertasLimpieza(data);
    } catch {
      setAlertasLimpiezaError(true);
      setAlertasLimpieza(null);
    } finally {
      setAlertasLimpiezaLoading(false);
    }
  };

  const cargarDetalleAusencias = async (rango?: { desde?: string; hasta?: string }) => {
    setAusenciasDetalleLoading(true);
    setAusenciasDetalleError(false);
    try {
      const data = rango?.desde || rango?.hasta
        ? await obtenerDetalleAusencias({
            desde: rango?.desde,
            hasta: rango?.hasta,
          })
        : await obtenerDetalleAusencias(fechaHoyIso());
      setAusenciasDetalle(data || []);
    } catch (e) {
      setAusenciasDetalleError(true);
      setAusenciasDetalle([]);
    } finally {
      setAusenciasDetalleLoading(false);
    }
  };

  const aplicarFiltroAusencias = () => {
    const desde = ausenciasDesde || undefined;
    const hasta = ausenciasHasta || undefined;
    if (!desde && !hasta) {
      cargarDetalleAusencias();
      return;
    }
    cargarDetalleAusencias({ desde, hasta });
  };

  const evaluarPerfil = async () => {
    try {
      const estado = await getEstadoPerfil();
      const needs = Boolean(estado.needsUpdate);
      setReasons(estado.missingFields && estado.missingFields.length ? estado.missingFields : ["Completa tus datos personales"]);
      setShowAlert(needs);
      // En Home NO abrimos el modal automáticamente: solo mostramos el banner
      // "Actualizá tus datos" con el botón "Actualizar ahora". El modal se abre
      // cuando el operario hace click en ese botón, o de forma forzada al entrar
      // a las rutas bloqueadas (salarios / historial / reclamos) vía PerfilGuard.
    } catch (e) {
      // Si el backend falla, mostramos el banner para forzar la actualización
      setReasons(["Completa tus datos personales"]);
      setShowAlert(true);
    }
  }

  const abrirModal = () => {
    setShowModal(true);
  };

  const cerrarModal = () => {
    setShowModal(false);
  };

  const onSaved = () => {
    // Notificar al guard global (App.tsx / useEstadoPerfil) para liberar bloqueos.
    window.dispatchEvent(new Event("perfil-actualizacion-refetch"));
    // Re-evaluamos el estado para ocultar el banner si completó todo
    evaluarPerfil();
  };

  const cargarUnidadesMarcacion = async () => {
    setUnidadesMarcacionLoading(true);
    setUnidadesMarcacionError("");
    try {
      const data = await obtenerUnidadesMarcacion();
      setUnidadesMarcacion(data);
    } catch {
      setUnidadesMarcacionError("No se pudieron cargar las unidades.");
      setUnidadesMarcacion([]);
    } finally {
      setUnidadesMarcacionLoading(false);
    }
  };

  const abrirMarcacionesModal = () => {
    setShowMarcacionesModal(true);
    cargarUnidadesMarcacion();
  };

  const cerrarMarcacionesModal = () => {
    setShowMarcacionesModal(false);
  };

  const toggleUnidadMarcacion = (id: number, checked: boolean) => {
    setUnidadesMarcacion((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, seleccionada: checked } : item
      )
    );
  };

  const guardarUnidadesMarcacion = async () => {
    setUnidadesMarcacionSaving(true);
    setUnidadesMarcacionError("");
    try {
      const seleccionadas = unidadesMarcacion
        .filter((item) => item.activo && item.seleccionada)
        .map((item) => item.id);
      const data = await actualizarUnidadesMarcacion(seleccionadas);
      setUnidadesMarcacion(data);
      present({ message: "Unidades actualizadas.", duration: 3000, color: "success" });
    } catch {
      setUnidadesMarcacionError("No se pudieron guardar las unidades.");
    } finally {
      setUnidadesMarcacionSaving(false);
    }
  };

  const sincronizarUnidadesMarcacionHandler = async () => {
    setUnidadesMarcacionSyncing(true);
    setUnidadesMarcacionError("");
    try {
      const res = await sincronizarUnidadesMarcacion();
      setUnidadesMarcacion(res.datos);
      present({
        message: `Sincronizacion completa. Nuevas: ${res.insertados}.`,
        duration: 3000,
        color: "success",
      });
    } catch {
      setUnidadesMarcacionError("No se pudo sincronizar las unidades.");
    } finally {
      setUnidadesMarcacionSyncing(false);
    }
  };

  const cargarCargosOrganizacion = async () => {
    setCargosOrganizacionLoading(true);
    setCargosOrganizacionError("");
    try {
      const data = await obtenerCargosOrganizacion();
      setCargosOrganizacion(data);
    } catch {
      setCargosOrganizacionError("No se pudieron cargar los cargos.");
      setCargosOrganizacion([]);
    } finally {
      setCargosOrganizacionLoading(false);
    }
  };

  const abrirCargosModal = () => {
    setShowCargosModal(true);
    cargarCargosOrganizacion();
  };

  const cerrarCargosModal = () => {
    setShowCargosModal(false);
  };

  const toggleCargoOrganizacion = (cargo: string, checked: boolean) => {
    setCargosOrganizacion((prev) =>
      prev.map((item) =>
        item.cargo === cargo ? { ...item, es_adm: checked } : item
      )
    );
  };

  const guardarCargosOrganizacion = async () => {
    setCargosOrganizacionSaving(true);
    setCargosOrganizacionError("");
    try {
      const data = await actualizarCargosOrganizacion(cargosOrganizacion);
      setCargosOrganizacion(data);
      present({ message: "Cargos actualizados.", duration: 3000, color: "success" });
    } catch {
      setCargosOrganizacionError("No se pudieron guardar los cargos.");
    } finally {
      setCargosOrganizacionSaving(false);
    }
  };

  const esDev = isDevCargo(cargoUsuario);
  const cargoNormUsuario = (cargoUsuario || "").toLowerCase();
  const esOperario =
    cargoNormUsuario.includes("operario") || cargoNormUsuario.includes("operaria");
  const mostrarKpis = featureSwitchesLoaded ? featureSwitches.homeKpis : false;
  const puedeVerSettings = cedulaUsuario === "5355286";
  const puedeVerMensajes = cedulaUsuario === "5355286";

  return (
    <IonPage>
      <Header titulo="Inicio" />

      <IonContent id="home">
        <div className="home-content">
          <BannerActivarNotificaciones />

          {/* Microencuesta sin responder (ingreso o Clima Laboral). No pinta
              nada si no tiene ninguna pendiente. */}
          <MicroEncuestaCard />

          <EventosInvitacionCard />

          {/* Agendamientos: proxima cita, encuestas pendientes y agendas
              disponibles. No pinta nada si no hay ninguna. */}
          <AgendaHomeCard />

          <EntregasRecepcionesCard />

          {/* Solicitudes a RRHH esperando la aprobacion de este usuario como
              jefe directo. No pinta nada si no tiene ninguna. */}
          <SolicitudesAprobarCard />

          {/* Capacitaciones asignadas al capacitador técnico (programadas o
              por cerrar). No pinta nada si no es capacitador o no tiene. */}
          <CapacitacionesPendientesCard />

          {/* Solicitudes de capacitación del usuario con nueva fecha propuesta
              por la Coordinación, esperando que la acepte. No pinta nada si no tiene. */}
          <CapacitacionesPropuestasCard />

          {/* SST: acciones correctivas de condiciones inseguras asignadas a
              este usuario (nuevas o devueltas). No pinta nada si no tiene. */}
          <AccionesCorrectivasCard />

          {/* Solicitudes a SST devueltas al usuario para corregir. No pinta
              nada si no tiene ninguna. */}
          <SolicitudesSstDevueltasCard />

          {showAlert && (
            <div className="container mt-1">
              <AlertActualizaDatos
                reasons={reasons}
                onEditar={abrirModal}
              />
            </div>
          )}

          <div className="container mt-1 home-main">
          <div className="d-flex justify-content-center">
            {isLoading && (
              <p>Cargando inicio...</p>
            )}
            {!isLoading && frase && frase.mensaje && (
              <figure className={`mensaje-inicio mensaje-inicio--${frase.categoria}`}>
                <figcaption className="mensaje-inicio__categoria">
                  {CATEGORIA_CONFIG[frase.categoria] && (
                    <IonIcon
                      className="mensaje-inicio__icono"
                      icon={CATEGORIA_CONFIG[frase.categoria].icono}
                    />
                  )}
                  <span>
                    {CATEGORIA_CONFIG[frase.categoria]?.etiqueta ?? frase.categoria}
                  </span>
                </figcaption>
                <blockquote>
                  <p>{frase.mensaje}</p>
                </blockquote>
              </figure>
            )}
          </div>

          {esOperario && <MiDiaCard />}

          {esOperario && <MiRutinaCard />}

          {puedeVerSettings && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => history.push("/settings")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    history.push("/settings");
                  }
                }}
              >
                <div className="kpi-title">Settings</div>
                <div className="kpi-item-row">Configurar switches globales</div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => history.push("/settings/modulos")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    history.push("/settings/modulos");
                  }
                }}
              >
                <div className="kpi-title">Permisos Modulos</div>
                <div className="kpi-item-row">Administrar visibilidad por cargo</div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={abrirMarcacionesModal}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    abrirMarcacionesModal();
                  }
                }}
              >
                <div className="kpi-title">Gestionar Marcaciones</div>
                <div className="kpi-item-row">Filtrar unidades de negocio</div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={abrirCargosModal}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    abrirCargosModal();
                  }
                }}
              >
                <div className="kpi-title">Organización Cargos</div>
                <div className="kpi-item-row">Clasificar cargos ADM / Operativo</div>
              </div>
            </div>
          )}

          {puedeVerMensajes && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => history.push("/mensajes")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    history.push("/mensajes");
                  }
                }}
              >
                <div className="kpi-title">Mensajes</div>
                <div className="kpi-item-row">Panel de conversaciones y grupos</div>
              </div>
            </div>
          )}

          {puedeVerAlertasLimpiezaJefe && alertasLimpiezaLoading && (
            <p className="text-center">Cargando alertas de limpieza general...</p>
          )}
          {puedeVerAlertasLimpiezaJefe && alertasLimpiezaError && (
            <p className="text-center">No se pudieron cargar las alertas de limpieza general.</p>
          )}
          {puedeVerAlertasLimpiezaJefe && !alertasLimpiezaLoading && !alertasLimpiezaError && alertasLimpieza && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-wide-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => setShowAlertasLimpiezaModal(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowAlertasLimpiezaModal(true);
                  }
                }}
              >
                <div className="kpi-title">Alertas de Visita</div>
                <div className="kpi-value">{alertasLimpieza.total ?? 0}</div>
              </div>
            </div>
          )}

          {puedeVerKpisJefe && mostrarKpis && (
            <div className="kpi-grid kpi-grid-main">
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowReclamosModal(true);
                  if (reclamosDetalle.length === 0 && !reclamosDetalleLoading) {
                    cargarDetalleReclamos();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowReclamosModal(true);
                    if (reclamosDetalle.length === 0 && !reclamosDetalleLoading) {
                      cargarDetalleReclamos();
                    }
                  }
                }}
              >
                <div className="kpi-title">Reclamos de operario</div>
                <div className="kpi-value">
                  {reclamosDetalleLoading ? "--" : reclamosDetalle.length}
                </div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowReclamosClientesModal(true);
                  if (reclamosClientes.length === 0 && !reclamosClientesLoading) {
                    cargarReclamosClientes();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowReclamosClientesModal(true);
                    if (reclamosClientes.length === 0 && !reclamosClientesLoading) {
                      cargarReclamosClientes();
                    }
                  }
                }}
              >
                <div className="kpi-title">Reclamos de cliente</div>
                <div className="kpi-value">
                  {reclamosClientesLoading ? "--" : reclamosClientes.length}
                </div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowOrdenesPendientesModal(true);
                  if (ordenesPendientes.length === 0 && !ordenesPendientesLoading) {
                    cargarOrdenesPendientes();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowOrdenesPendientesModal(true);
                    if (ordenesPendientes.length === 0 && !ordenesPendientesLoading) {
                      cargarOrdenesPendientes();
                    }
                  }
                }}
              >
                <div className="kpi-title">Órdenes a aprobar</div>
                <div className="kpi-value">
                  {ordenesPendientesLoading ? "--" : ordenesPendientes.length}
                </div>
              </div>
            </div>
          )}

          {puedeVerKpisJefe && mostrarKpis && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-wide-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => setShowEncuestasBajasModal(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setShowEncuestasBajasModal(true);
                }}
              >
                <div className="kpi-title">ENCUESTAS MENORES O IGUAL A 7</div>
                <div className="kpi-mini-list">
                  <div className="kpi-mini-row">
                    <span>Calificacion de Nuestros Colaboradores que Realizan el Servicio</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.colaboradores ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Calificacion de la Calidad de la Limpieza</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.limpieza ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Estado de los Equipos y Maquinas</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.equipos ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Satisfaccion de los Productos e Insumos Proveidos</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.productos ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Calificacion de la Gestion del Fiscal</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.fiscal ?? 0}
                    </strong>
                  </div>
                  {encuestasBajasError && (
                    <div className="kpi-mini-row">
                      <span>No se pudieron cargar los datos</span>
                      <strong>--</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Card Repro: oculta de momento (Repro ya no se está usando).
          {puedeVerKpis && statsRepro && statsRepro.total_asignados > 0 && (
            <div className="kpi-grid kpi-grid-main">
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => history.push("/relevamiento-operativo")}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    history.push("/relevamiento-operativo");
                  }
                }}
                style={{ gridColumn: "1 / -1" }}
              >
                <div className="kpi-title">Repro — Progreso</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: 8,
                    marginTop: 4,
                  }}
                >
                  <span style={{ fontSize: 28, fontWeight: 700 }}>
                    {statsRepro.con_relevamiento}
                  </span>
                  <span style={{ fontSize: 18, color: "#666" }}>
                    / {statsRepro.total_asignados}
                  </span>
                  <span
                    style={{
                      marginLeft: "auto",
                      color: "#666",
                      fontSize: 14,
                    }}
                  >
                    {Math.round(
                      (statsRepro.con_relevamiento / statsRepro.total_asignados) * 100
                    )}
                    %
                  </span>
                </div>
                <div
                  style={{
                    height: 8,
                    background: "#e0e0e0",
                    borderRadius: 4,
                    overflow: "hidden",
                    marginTop: 6,
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: `${
                        (statsRepro.con_relevamiento / statsRepro.total_asignados) * 100
                      }%`,
                      background:
                        statsRepro.con_relevamiento === statsRepro.total_asignados
                          ? "#28ba62"
                          : statsRepro.con_relevamiento / statsRepro.total_asignados >= 0.5
                          ? "#3880ff"
                          : "#ffc409",
                      transition: "width 0.3s",
                    }}
                  />
                </div>
                <div style={{ fontSize: 12, color: "#666", marginTop: 6 }}>
                  Puntos de servicio con Repro completado
                </div>
              </div>
            </div>
          )}
          */}

          {puedeVerKpis && mostrarKpis && kpisLoading && (
            <p className="text-center">Cargando indicadores...</p>
          )}
          {puedeVerKpis && mostrarKpis && kpisError && (
            <p className="text-center">No se pudieron cargar indicadores.</p>
          )}
          {puedeVerKpis && mostrarKpis && !kpisLoading && !kpisError && kpis && (
            <div className="kpi-grid kpi-grid-main">
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowVisitasModal(true);
                  cargarDetalleVisitas();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowVisitasModal(true);
                    cargarDetalleVisitas();
                  }
                }}
              >
                <div className="kpi-title">Visitas</div>
                <div className="kpi-value">{kpis.visitas.total}</div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowSinAModal(true);
                  cargarDetalleSinA();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowSinAModal(true);
                    cargarDetalleSinA();
                  }
                }}
              >
                <div className="kpi-title">SIN-A</div>
                <div className="kpi-value">{kpis.sin_a.total}</div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowReclamosModal(true);
                  cargarDetalleReclamos();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowReclamosModal(true);
                    cargarDetalleReclamos();
                  }
                }}
              >
                <div className="kpi-title">Reclamos de operario</div>
                <div className="kpi-value">{kpis.reclamos.total}</div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowReclamosClientesModal(true);
                  if (reclamosClientes.length === 0 && !reclamosClientesLoading) {
                    cargarReclamosClientes();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowReclamosClientesModal(true);
                    if (reclamosClientes.length === 0 && !reclamosClientesLoading) {
                      cargarReclamosClientes();
                    }
                  }
                }}
              >
                <div className="kpi-title">Reclamos de cliente</div>
                <div className="kpi-value">
                  {reclamosClientesLoading ? "--" : reclamosClientes.length}
                </div>
              </div>
              <div
                className="kpi-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowAusenciasModal(true);
                  setAusenciasDesde("");
                  setAusenciasHasta("");
                  cargarDetalleAusencias();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowAusenciasModal(true);
                    setAusenciasDesde("");
                    setAusenciasHasta("");
                    cargarDetalleAusencias();
                  }
                }}
              >
                <div className="kpi-title">Ausencias</div>
                <div className="kpi-value">{ausenciasHoyTotal ?? kpis.ausencias?.total ?? 0}</div>
              </div>
            </div>
          )}
          {puedeVerKpis && mostrarKpis && !kpisLoading && !kpisError && kpis && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-wide-card kpi-clickable kpi-vac-home-card"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setShowVacacionesModal(true);
                  if (!vacaciones && !vacacionesLoading) {
                    cargarVacaciones();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowVacacionesModal(true);
                    if (!vacaciones && !vacacionesLoading) {
                      cargarVacaciones();
                    }
                  }
                }}
              >
                <div className="kpi-title">Vacaciones</div>
                <div className="kpi-item-row kpi-vac-home-summary">
                  Por vencer: <strong>{vacaciones?.resumen?.proximos ?? 0}</strong>
                  {" | "}
                  Vencido: <strong>{vacaciones?.resumen?.vencidos ?? 0}</strong>
                  {" | "}
                  Al día: <strong>{vacaciones?.datos?.filter((item) => !item.proximo && !item.vencido).length ?? 0}</strong>
                </div>
              </div>
            </div>
          )}
          {puedeVerKpis && mostrarKpis && !kpisLoading && !kpisError && kpis && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-wide-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => setShowEncuestasBajasModal(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setShowEncuestasBajasModal(true);
                }}
              >
                <div className="kpi-title">ENCUESTAS MENORES O IGUAL A 7</div>
                <div className="kpi-mini-list">
                  <div className="kpi-mini-row">
                    <span>Calificacion de Nuestros Colaboradores que Realizan el Servicio</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.colaboradores ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Calificacion de la Calidad de la Limpieza</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.limpieza ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Estado de los Equipos y Maquinas</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.equipos ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Satisfaccion de los Productos e Insumos Proveidos</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.productos ?? 0}
                    </strong>
                  </div>
                  <div className="kpi-mini-row">
                    <span>Calificacion de la Gestion del Fiscal</span>
                    <strong>
                      {encuestasBajasLoading ? "--" : encuestasBajas?.fiscal ?? 0}
                    </strong>
                  </div>
                  {encuestasBajasError && (
                    <div className="kpi-mini-row">
                      <span>No se pudieron cargar los datos</span>
                      <strong>--</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {puedeVerKpis && mostrarKpis && lpResumenLoading && (
            <p className="text-center">Cargando Limpiezas Profundas...</p>
          )}
          {puedeVerKpis && mostrarKpis && lpResumenError && (
            <p className="text-center">No se pudieron cargar Limpiezas Profundas.</p>
          )}
          {puedeVerKpis && mostrarKpis && !lpResumenLoading && !lpResumenError && lpResumen && (
            <div className="kpi-grid">
              <div
                className="kpi-card kpi-wide-card kpi-clickable"
                role="button"
                tabIndex={0}
                onClick={() => setShowLpModal(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setShowLpModal(true);
                  }
                }}
              >
                <div className="kpi-title">Limpiezas profundas - {lpEtiquetaMes}</div>
                <div className="kpi-lp-header">
                  <div className="kpi-lp-chart">
                    {lpFrecuencias.map((item) => (
                      <div className="kpi-lp-bar" key={`lp-freq-${item.key}`}>
                        <div className="kpi-lp-bar-label">{item.label}</div>
                        <div className="kpi-lp-bar-track">
                          <span
                            className="kpi-lp-bar-fill"
                            style={{ width: `${Math.round((item.total / lpMaxFrecuencia) * 100)}%` }}
                          />
                        </div>
                        <div className="kpi-lp-bar-value">{item.total}</div>
                      </div>
                    ))}
                    <div className="kpi-lp-total-row">
                      <span>Total mensual</span>
                      <strong>{lpResumen.resumen?.total ?? 0}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* <CustomCarousel/> */}

          <div className="position-absolute right-1 bottom-1 poner-detras home-personajes-desktop">
            <img src="assets/images/personajes-01.png" height="200px" alt="personaje 01"/>
            <img src="assets/images/personajes-11.png" height="180px" alt="personaje 11"/>
          </div>
          </div>
          <div className="home-personajes-mobile">
            <img src="assets/images/group-personajes.png" alt="personajes" />
          </div>
        </div>

        <ActualizarDatosModal
          isOpen={showModal}
          forzado={showAlert}
          onClose={cerrarModal}
          onSaved={onSaved}
        />

        <IonModal
          isOpen={showMarcacionesModal}
          onDidDismiss={cerrarMarcacionesModal}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Gestionar Marcaciones</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={cerrarMarcacionesModal}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {unidadesMarcacionLoading && (
              <div className="text-center">
                <IonSpinner />
              </div>
            )}
            {!unidadesMarcacionLoading && unidadesMarcacionError && (
              <div className="kpi-gestion-error">{unidadesMarcacionError}</div>
            )}
            {!unidadesMarcacionLoading && !unidadesMarcacionError && (
              <IonList>
                {unidadesMarcacion.map((item) => (
                  <IonItem key={`unidad-${item.id}`}>
                    <IonLabel>
                      <div>{item.unidad}</div>
                      <div className="kpi-item-row">Codigo: {item.codigo}</div>
                    </IonLabel>
                    <IonCheckbox
                      slot="end"
                      checked={item.seleccionada}
                      disabled={!item.activo || unidadesMarcacionSaving}
                      onIonChange={(e) =>
                        toggleUnidadMarcacion(item.id, Boolean(e.detail.checked))
                      }
                    />
                  </IonItem>
                ))}
              </IonList>
            )}
            <div className="kpi-gestion-actions">
              <IonButton
                onClick={guardarUnidadesMarcacion}
                disabled={unidadesMarcacionLoading || unidadesMarcacionSaving || unidadesMarcacionSyncing}
              >
                {unidadesMarcacionSaving ? "Guardando..." : "Guardar"}
              </IonButton>
              <IonButton
                fill="outline"
                onClick={sincronizarUnidadesMarcacionHandler}
                disabled={unidadesMarcacionLoading || unidadesMarcacionSaving || unidadesMarcacionSyncing}
              >
                {unidadesMarcacionSyncing ? "Sincronizando..." : "Sincronizar"}
              </IonButton>
            </div>
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showCargosModal}
          onDidDismiss={cerrarCargosModal}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Organización Cargos</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={cerrarCargosModal}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {cargosOrganizacionLoading && (
              <div className="text-center">
                <IonSpinner />
              </div>
            )}
            {!cargosOrganizacionLoading && cargosOrganizacionError && (
              <div className="kpi-gestion-error">{cargosOrganizacionError}</div>
            )}
            {!cargosOrganizacionLoading && !cargosOrganizacionError && (
              <IonList>
                {cargosOrganizacion.map((item) => (
                  <IonItem key={`cargo-${item.cargo}`}>
                    <IonLabel>
                      <div>{item.cargo}</div>
                      <div className="kpi-item-row">{item.es_adm ? "ADM" : "Operativo"}</div>
                    </IonLabel>
                    <IonToggle
                      slot="end"
                      checked={item.es_adm}
                      disabled={cargosOrganizacionSaving}
                      onIonChange={(e) =>
                        toggleCargoOrganizacion(item.cargo, Boolean(e.detail.checked))
                      }
                    />
                  </IonItem>
                ))}
              </IonList>
            )}
            <div className="kpi-gestion-actions">
              <IonButton
                onClick={guardarCargosOrganizacion}
                disabled={cargosOrganizacionLoading || cargosOrganizacionSaving}
              >
                {cargosOrganizacionSaving ? "Guardando..." : "Guardar"}
              </IonButton>
            </div>
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showLpModal}
          onDidDismiss={() => setShowLpModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>
                Limpiezas profundas {lpEtiquetaMes ? `- ${lpEtiquetaMes}` : ""}
              </IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowLpModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {!lpResumen && <p>No hay datos para mostrar.</p>}
            {lpResumen && lpPuntosConLp.length === 0 && (
              <p>Sin planificaciones para el mes.</p>
            )}
            {lpResumen && lpPuntosConLp.length > 0 && (
              <div className="kpi-lp-table-scroll" role="region" aria-label="Frecuencia por punto de servicio">
                <table className="kpi-lp-table">
                  <thead>
                    <tr>
                      <th>Punto de servicio</th>
                      <th>Total</th>
                      {lpFrecuencias.map((item) => (
                        <th key={`lp-modal-th-${item.key}`}>{item.label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {lpPuntosConLp.map((ps) => (
                      <tr
                        key={`lp-modal-ps-${ps.ps_codigo || ps.ps_id || ps.ps_nombre}`}
                        className="kpi-lp-row"
                        role="button"
                        tabIndex={0}
                        onClick={() => abrirLpDesdeModal(ps)}
                        onKeyDown={(ev) => {
                          if (ev.key === "Enter") {
                            abrirLpDesdeModal(ps);
                          }
                        }}
                      >
                        <td>
                          <div className="kpi-lp-ps-name">{ps.ps_nombre || "-"}</div>
                          <div className="kpi-lp-ps-code">{ps.ps_codigo || ""}</div>
                        </td>
                        <td className="kpi-lp-num">{ps.total ?? 0}</td>
                        {lpFrecuencias.map((item) => (
                          <td className="kpi-lp-num" key={`lp-modal-ps-${ps.ps_codigo}-${item.key}`}>
                            {ps.por_frecuencia?.[item.key] ?? 0}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showAlertasLimpiezaModal}
          onDidDismiss={() => setShowAlertasLimpiezaModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Alertas de Visita</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowAlertasLimpiezaModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            <div className="kpi-list" style={{ marginBottom: 10 }}>
              <div className="kpi-item">
                <div className="kpi-item-row">
                  Rango analizado:{" "}
                  <strong>
                    {formatFecha(alertasLimpieza?.desde)} al {formatFecha(alertasLimpieza?.hasta)}
                  </strong>
                </div>
                <div className="kpi-item-row">
                  Puntos de servicio a visitar: <strong>{alertasLimpieza?.total ?? 0}</strong>
                </div>
              </div>
            </div>
            {alertasLimpiezaLoading && <p>Cargando alertas...</p>}
            {alertasLimpiezaError && <p>No se pudieron cargar las alertas.</p>}
            {!alertasLimpiezaLoading &&
              !alertasLimpiezaError &&
              (!alertasLimpieza || alertasLimpieza.datos.length === 0) && (
                <p>Sin puntos de servicio con alertas de limpieza general en el rango actual.</p>
              )}
            {!alertasLimpiezaLoading &&
              !alertasLimpiezaError &&
              alertasLimpieza &&
              alertasLimpieza.datos.length > 0 && (
                <div className="kpi-list">
                  {alertasLimpieza.datos.map((item, idx) => {
                    const origenLabel =
                      item.origen === "evaluacion_visita"
                        ? "Visita Jefe / Gerencia"
                        : item.origen === "visita_comercial"
                        ? "Visita Comercial"
                        : "Fiscalización Limpieza";
                    const idKey =
                      item.fiscalizacion_id ||
                      item.evaluacion_id ||
                      item.visita_id ||
                      idx;
                    return (
                      <div
                        className="kpi-item"
                        key={`alerta-${item.origen || "fis"}-${idKey}-${item.ps_codigo || ""}`}
                      >
                        <div className="kpi-item-title">
                          {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                        </div>
                        <div className="kpi-item-row">
                          Tipo: <strong>{origenLabel}</strong>
                        </div>
                        {item.ps_codigo && (
                          <div className="kpi-item-row">Código: {item.ps_codigo}</div>
                        )}
                        <div className="kpi-item-row">
                          Calificación: <strong>{item.calificacion || "-"}</strong>
                        </div>
                        <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                        {item.origen === "fiscalizacion_limpieza" && (
                          <div className="kpi-item-row">
                            Fiscalizador: {item.fiscal_nombre || item.fiscal_cedula || "-"}
                          </div>
                        )}
                        {item.origen === "evaluacion_visita" && (
                          <>
                            {item.fiscal_nombre && (
                              <div className="kpi-item-row">
                                Fiscal: {item.fiscal_nombre}
                              </div>
                            )}
                            {item.visitado_por && (
                              <div className="kpi-item-row">
                                Visitado por: {item.visitado_por}
                              </div>
                            )}
                          </>
                        )}
                        {item.origen === "visita_comercial" && item.visitado_por && (
                          <div className="kpi-item-row">
                            Ejecutivo: {item.visitado_por}
                          </div>
                        )}
                        {item.origen === "fiscalizacion_limpieza" && (
                          <div className="kpi-item-row">
                            <strong>{item.mensaje || "Debe visitarlo"}</strong>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showVisitasModal}
          onDidDismiss={() => setShowVisitasModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Visitas de hoy</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowVisitasModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {visitasDetalleLoading && <p>Cargando visitas...</p>}
            {visitasDetalleError && <p>No se pudieron cargar las visitas.</p>}
            {!visitasDetalleLoading && !visitasDetalleError && visitasDetalle.length === 0 && (
              <p>Sin visitas para hoy.</p>
            )}
            {!visitasDetalleLoading && !visitasDetalleError && visitasDetalle.length > 0 && (
              <div className="kpi-list">
                {visitasDetalle.map((item) => (
                  <div className="kpi-item" key={`visita-${item.id}`}>
                    <div className="kpi-item-title">
                      {item.ps_nombre || item.ps_objeto || "Punto de servicio"}
                    </div>
                    <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                    <div className="kpi-item-row">Estado: {item.estado}</div>
                    <div className="kpi-item-row">Prioridad: {item.prioridad}</div>
                    {item.comentario && (
                      <div className="kpi-item-row">Comentario: {item.comentario}</div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showSinAModal}
          onDidDismiss={() => setShowSinAModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>SIN-A de hoy</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowSinAModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            <div className="kpi-filter">
              <input
                className="kpi-filter-input"
                type="text"
                placeholder="Buscar PS (min 3 letras)"
                value={sinAFiltro}
                onChange={(e) => setSinAFiltro(e.target.value)}
              />
            </div>
            {sinADetalleLoading && <p>Cargando SIN-A...</p>}
            {sinADetalleError && <p>No se pudieron cargar los SIN-A.</p>}
            {!sinADetalleLoading && !sinADetalleError && sinADetalle.length === 0 && (
              <p>Sin SIN-A para hoy.</p>
            )}
            {!sinADetalleLoading && !sinADetalleError && sinADetalle.length > 0 && sinAFiltro.trim().length > 0 && sinAFiltro.trim().length < 3 && (
              <p>Escribi al menos 3 letras para filtrar.</p>
            )}
            {!sinADetalleLoading && !sinADetalleError && sinADetalle.length > 0 && (
              <div className="kpi-list">
                {filtrarPorPs(
                  sinADetalle,
                  sinAFiltro,
                  (item) => `${item.ps_nombre || ""} ${item.ps_codigo || ""}`
                ).map((item) => (
                  <div className="kpi-item" key={`sina-${item.id}`}>
                    <div className="kpi-item-title">
                      {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                    </div>
                    <div className="kpi-item-row">
                      Operario: {getOperarioNombre(item) || "N/A"}
                      {getOperarioLegajo(item) ? ` (${getOperarioLegajo(item)})` : ""}
                    </div>
                    <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                    <div className="kpi-item-row">
                      Entrada: {formatHora(item.hora_entrada)} | Salida: {formatHora(item.hora_salida)}
                    </div>
                    {featureSwitches.sinaGestionar && puedeVerKpis && (
                      <div className="kpi-item-actions">
                        <button
                          type="button"
                          className="kpi-action-btn"
                          onClick={() => abrirSelectorGestion(item)}
                        >
                          Gestionar
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showGestionSelectorModal}
          onDidDismiss={cerrarSelectorGestion}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Seleccionar acción</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={cerrarSelectorGestion}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            <div className="kpi-gestion-form">
              <div className="kpi-gestion-actions">
                <IonButton
                  onClick={() => {
                    const item = gestionSelectorItem;
                    cerrarSelectorGestion();
                    if (item) abrirGestionRapida(item);
                  }}
                >
                  Reemplazo rapido
                </IonButton>
                <IonButton
                  fill="outline"
                  onClick={() => {
                    const item = gestionSelectorItem;
                    if (item) abrirNuevaAsignacion(item);
                  }}
                >
                  Nueva asignacion
                </IonButton>
              </div>
            </div>
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showGestionModal}
          onDidDismiss={cerrarGestionRapida}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Gestión rápida SIN-A</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={cerrarGestionRapida}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            <div className="kpi-gestion-form">
              <div className="kpi-gestion-field">
                <label>Reemplazante (SIN-A)</label>
                <input type="text" value={gestionReemplazante} disabled />
              </div>
              <div className="kpi-gestion-field">
                <label>Punto de Servicio</label>
                <input type="text" value={gestionPs} disabled />
              </div>
              <div className="kpi-gestion-field">
                <label>Fecha SIN-A</label>
                <input type="date" value={gestionFecha} disabled />
              </div>
              <div className="kpi-gestion-row">
                <div className="kpi-gestion-field">
                  <label>Entrada</label>
                  <input type="time" value={gestionHoraEntrada} disabled />
                </div>
                <div className="kpi-gestion-field">
                  <label>Salida</label>
                  <input type="time" value={gestionHoraSalida} disabled />
                </div>
              </div>
              <div className="kpi-gestion-field">
                <label>Reemplazado (ausente)</label>
                <Autocomplete
                  className="kpi-gestion-autocomplete"
                  options={gestionOperarios}
                  value={gestionReemplazado}
                  onChange={(_, v) => setGestionReemplazado(v)}
                  getOptionLabel={(option) => option || ""}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder="Seleccionar" />
                  )}
                />
              </div>
              <div className="kpi-gestion-field">
                <label>Motivo</label>
                <select value={gestionMotivo} onChange={(e) => setGestionMotivo(e.target.value)}>
                  <option value="" disabled>Seleccionar motivo</option>
                  {motivosReemplazo.map((m) => (
                    <option key={m.value} value={m.value}>{m.label}</option>
                  ))}
                </select>
              </div>
              <div className="kpi-gestion-field">
                <label>Fecha ausencia</label>
                <DatePicker
                  className="kpi-gestion-datepicker"
                  placeholder=""
                  value={gestionFechaAusencia ? new Date(`${gestionFechaAusencia}T00:00:00`) : undefined}
                  setValue={(date) =>
                    setGestionFechaAusencia(date ? date.toISOString().slice(0, 10) : "")
                  }
                />
              </div>
              <div className="kpi-gestion-field">
                <label>Cupos disponibles</label>
                <input type="text" value={gestionCupoLoading ? "Calculando..." : gestionCupo} disabled />
                {gestionCupoError && <div className="kpi-gestion-error">{gestionCupoError}</div>}
              </div>
              {gestionSaveError && <div className="kpi-gestion-error">{gestionSaveError}</div>}
              <div className="kpi-gestion-actions">
                <IonButton fill="outline" onClick={cerrarGestionRapida}>Cancelar</IonButton>
                <IonButton onClick={guardarGestionRapida} disabled={gestionSaving}>
                  {gestionSaving ? "Guardando..." : "Guardar"}
                </IonButton>
              </div>
            </div>
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showVacacionesModal}
          onDidDismiss={() => setShowVacacionesModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Vacaciones</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowVacacionesModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {vacacionesLoading && <p>Cargando vacaciones...</p>}
            {vacacionesError && <p>No se pudieron cargar las vacaciones.</p>}
            {!vacacionesLoading && !vacacionesError && (!vacaciones || vacaciones.datos.length === 0) && (
              <p>Sin datos de vacaciones para mostrar.</p>
            )}
            {!vacacionesLoading && !vacacionesError && vacaciones && vacaciones.datos.length > 0 && (
              <>
                <div className="kpi-list" style={{ marginBottom: 10 }}>
                  <div className="kpi-item">
                    <div className="kpi-item-row">Próximos a causar dentro de {vacaciones.dias_alerta} días: <strong>{vacaciones.resumen.proximos}</strong></div>
                    <div className="kpi-item-row">Vencidos (años anteriores con saldo): <strong>{vacaciones.resumen.vencidos}</strong></div>
                    <div className="kpi-item-row">Total operarios: <strong>{vacaciones.resumen.total}</strong></div>
                  </div>
                </div>
                <div className="kpi-vac-filters">
                  <button
                    type="button"
                    className={`kpi-vac-filter-btn kpi-vac-filter-btn--por-vencer ${vacacionesEstadoFiltro === "por_vencer" ? "is-active" : ""}`}
                    onClick={() => setVacacionesEstadoFiltro("por_vencer")}
                  >
                    Por vencer
                  </button>
                  <button
                    type="button"
                    className={`kpi-vac-filter-btn kpi-vac-filter-btn--al-dia ${vacacionesEstadoFiltro === "al_dia" ? "is-active" : ""}`}
                    onClick={() => setVacacionesEstadoFiltro("al_dia")}
                  >
                    Al día
                  </button>
                  <button
                    type="button"
                    className={`kpi-vac-filter-btn kpi-vac-filter-btn--vencido ${vacacionesEstadoFiltro === "vencido" ? "is-active" : ""}`}
                    onClick={() => setVacacionesEstadoFiltro("vencido")}
                  >
                    Vencido
                  </button>
                </div>
                <div className="kpi-list">
                  {filtrarVacacionesPorEstado(ordenarVacaciones(vacaciones.datos), vacacionesEstadoFiltro).map((item) => {
                    const estado = item.proximo && item.vencido
                      ? "Por vencer - Vencido"
                      : item.proximo
                        ? "Por vencer"
                        : item.vencido
                          ? "Vencido"
                          : "Al día";

                    const claseEstado = item.proximo
                        ? "kpi-item--vacaciones-por-vencer"
                      : item.vencido
                        ? "kpi-item--vacaciones-vencido"
                        : "kpi-item--vacaciones-al-dia";

                    return (
                    <div className={`kpi-item kpi-item--vacaciones ${claseEstado}`} key={`vac-${item.legajo}`}>
                      <div className="kpi-item-title">{item.nombre_empleado} ({item.legajo})</div>
                      <div className="kpi-item-row">Fecha inicio: {formatFecha(item.fecha_inicio)}</div>
                      <div className="kpi-item-row">Días faltantes: {item.dias_faltantes ?? "-"}</div>
                      <div className="kpi-item-row">Saldo años anteriores: {item.saldos_pendientes_anteriores}</div>
                      <div className="kpi-item-row">Total saldo: {item.total}</div>
                      <div className="kpi-item-row">
                        Estado: {estado}
                      </div>
                      <div className="kpi-item-row">
                        Años con saldo: {(item.saldos_anuales || []).map((y) => `${y.periodo}: ${y.saldo}`).join(" | ") || "-"}
                      </div>
                    </div>
                  )})}
                  {filtrarVacacionesPorEstado(ordenarVacaciones(vacaciones.datos), vacacionesEstadoFiltro).length === 0 && (
                    <div className="kpi-item">
                      <div className="kpi-item-row">No hay operarios para el estado seleccionado.</div>
                    </div>
                  )}
                </div>
              </>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showReclamosModal}
          onDidDismiss={() => setShowReclamosModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Reclamos de operario de hoy</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowReclamosModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {reclamosDetalleLoading && <p>Cargando reclamos...</p>}
            {reclamosDetalleError && <p>No se pudieron cargar los reclamos.</p>}
            {!reclamosDetalleLoading && !reclamosDetalleError && reclamosDetalle.length === 0 && (
              <p>Sin reclamos para hoy.</p>
            )}
            {!reclamosDetalleLoading && !reclamosDetalleError && reclamosDetalle.length > 0 && (
              <div className="kpi-list">
                {reclamosDetalle.map((item) => (
                  <div className="kpi-item" key={`reclamo-${item.id}`}>
                    <div className="kpi-item-title">
                      {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                    </div>
                    <div className="kpi-item-row">Operario: {item.op_nombre}</div>
                    <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                    <div className="kpi-item-row">Estado: {item.estado}</div>
                    <div className="kpi-item-row">Motivo: {item.reclamo}</div>
                  </div>
                ))}
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showEncuestasBajasModal}
          onDidDismiss={() => setShowEncuestasBajasModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Encuestas ≤ 7 (últimos 30 días)</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowEncuestasBajasModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {encuestasBajasLoading && <p>Cargando encuestas...</p>}
            {encuestasBajasError && <p>No se pudieron cargar las encuestas.</p>}
            {!encuestasBajasLoading && !encuestasBajasError && encuestasBajasDetalle.length === 0 && (
              <p>Sin encuestas con calificación menor o igual a 7 en los últimos 30 días.</p>
            )}
            {!encuestasBajasLoading && !encuestasBajasError && encuestasBajasDetalle.length > 0 && (
              <div className="kpi-list">
                {encuestasBajasDetalle.map((item) => (
                  <div className="kpi-item" key={`encuesta-baja-${item.caso_id}`}>
                    <div className="kpi-item-title">
                      {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                    </div>
                    <div className="kpi-item-row">Caso: {item.caso_id}</div>
                    <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                    {item.fiscal_nombre && (
                      <div className="kpi-item-row">Fiscal: {item.fiscal_nombre}</div>
                    )}
                    {ENCUESTA_CATEGORIAS.map(({ key, label }) => {
                      const nota = item[key];
                      if (nota === null || nota === undefined) return null;
                      const baja = nota < 8;
                      return (
                        <div
                          className="kpi-item-row"
                          key={key}
                          style={baja ? { color: "var(--ion-color-danger)", fontWeight: 600 } : undefined}
                        >
                          {label}: {nota}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showReclamosClientesModal}
          onDidDismiss={() => setShowReclamosClientesModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Reclamos de cliente (últimos 30 días)</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowReclamosClientesModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {reclamosClientesLoading && <p>Cargando reclamos...</p>}
            {reclamosClientesError && <p>No se pudieron cargar los reclamos.</p>}
            {!reclamosClientesLoading && !reclamosClientesError && reclamosClientes.length === 0 && (
              <p>Sin reclamos de cliente en los últimos 30 días.</p>
            )}
            {!reclamosClientesLoading && !reclamosClientesError && reclamosClientes.length > 0 && (
              <div className="kpi-list">
                {reclamosClientes.map((item) => (
                  <div className="kpi-item" key={`reclamo-cliente-${item.caso_id}`}>
                    <div className="kpi-item-title">
                      {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                    </div>
                    <div className="kpi-item-row">Caso: {item.caso_id}</div>
                    <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                    <div className="kpi-item-row">Estado: {item.estado || "-"}</div>
                    {item.clasificacion && (
                      <div className="kpi-item-row">Clasificación: {item.clasificacion}</div>
                    )}
                    {item.gravedad && (
                      <div className="kpi-item-row">Gravedad: {item.gravedad}</div>
                    )}
                    <div className="kpi-item-row">Conforme: {item.conforme || "Pendiente"}</div>
                    <div className="kpi-item-row">Descripción: {item.descripcion || "-"}</div>
                  </div>
                ))}
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showOrdenesPendientesModal}
          onDidDismiss={() => setShowOrdenesPendientesModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Órdenes a aprobar</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowOrdenesPendientesModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            {ordenesPendientesLoading && <p>Cargando órdenes pendientes...</p>}
            {ordenesPendientesError && <p>No se pudieron cargar las órdenes.</p>}
            {!ordenesPendientesLoading && !ordenesPendientesError && ordenesPendientes.length === 0 && (
              <p>Sin órdenes pendientes a aprobar.</p>
            )}
            {!ordenesPendientesLoading && !ordenesPendientesError && ordenesPendientes.length > 0 && (
              <div className="kpi-list">
                {ordenesPendientes.map((item) => {
                  const procesando = ordenDecidiendoId === item.id;
                  const bloqueado = ordenDecidiendoId !== null && !procesando;
                  return (
                    <div className="kpi-item" key={`orden-${item.id}`}>
                      <div className="kpi-item-title">
                        {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                      </div>
                      <div className="kpi-item-row">Tipo: {item.tipo_orden}</div>
                      <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                      {item.observacion && (
                        <div className="kpi-item-row">Observación: {item.observacion}</div>
                      )}
                      <div className="kpi-item-row" style={{ display: "flex", gap: 8, marginTop: 8 }}>
                        <IonButton
                          size="small"
                          color="success"
                          disabled={procesando || bloqueado}
                          onClick={() => decidirOrden(item.id, "aprobar")}
                        >
                          {procesando ? "Procesando..." : "Aprobar"}
                        </IonButton>
                        <IonButton
                          size="small"
                          color="danger"
                          disabled={procesando || bloqueado}
                          onClick={() => decidirOrden(item.id, "rechazar")}
                        >
                          Rechazar
                        </IonButton>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </IonContent>
        </IonModal>

        <IonModal
          isOpen={showAusenciasModal}
          onDidDismiss={() => setShowAusenciasModal(false)}
          cssClass="kpi-modal"
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>Ausencias</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowAusenciasModal(false)}>Cerrar</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="kpi-modal-body">
            <div className="kpi-filter kpi-filter-row">
              <div className="kpi-filter-field">
                <label>Desde</label>
                <DatePicker
                  className="kpi-gestion-datepicker"
                  placeholder=""
                  value={ausenciasDesde ? new Date(`${ausenciasDesde}T00:00:00`) : undefined}
                  setValue={(date) =>
                    setAusenciasDesde(date ? date.toISOString().slice(0, 10) : "")
                  }
                />
              </div>
              <div className="kpi-filter-field">
                <label>Hasta</label>
                <DatePicker
                  className="kpi-gestion-datepicker"
                  placeholder=""
                  value={ausenciasHasta ? new Date(`${ausenciasHasta}T00:00:00`) : undefined}
                  setValue={(date) =>
                    setAusenciasHasta(date ? date.toISOString().slice(0, 10) : "")
                  }
                />
              </div>
              <div className="kpi-filter-actions">
                <button type="button" className="kpi-filter-apply" onClick={aplicarFiltroAusencias}>
                  Aplicar
                </button>
              </div>
            </div>
            <div className="kpi-filter">
              <input
                className="kpi-filter-input"
                type="text"
                placeholder="Buscar PS (min 3 letras)"
                value={ausenciasFiltro}
                onChange={(e) => setAusenciasFiltro(e.target.value)}
              />
            </div>
            {ausenciasDetalleLoading && <p>Cargando ausencias...</p>}
            {ausenciasDetalleError && <p>No se pudieron cargar las ausencias.</p>}
            {!ausenciasDetalleLoading && !ausenciasDetalleError && ausenciasDetalle.length === 0 && (
              <p>Sin ausencias para hoy.</p>
            )}
            {!ausenciasDetalleLoading && !ausenciasDetalleError && ausenciasDetalle.length > 0 && ausenciasFiltro.trim().length > 0 && ausenciasFiltro.trim().length < 3 && (
              <p>Escribi al menos 3 letras para filtrar.</p>
            )}
            {!ausenciasDetalleLoading && !ausenciasDetalleError && ausenciasDetalle.length > 0 && (
              <div className="kpi-list">
                {filtrarPorPs(
                  ausenciasDetalle,
                  ausenciasFiltro,
                  (item) => `${item.ps_nombre || ""} ${item.ps_codigo || ""}`
                ).map((item, idx) => (
                  <div
                    className={`kpi-item kpi-item--ausencia kpi-item--ausencia-${item.tipo_ausencia || "asignacion"}`}
                    key={`ausencia-${idx}`}
                  >
                    <div className="kpi-item-title">
                      {item.ps_nombre || item.ps_codigo || "Punto de servicio"}
                    </div>
                    <div className="kpi-item-row">
                      Operario: {item.operario || "N/A"}
                      {item.legajo ? ` (${item.legajo})` : ""}
                    </div>
                    <div className="kpi-item-row">Fecha: {formatFecha(item.fecha)}</div>
                    <div className="kpi-item-row">
                      Entrada: {formatHora(item.hora_ent)} | Salida: {formatHora(item.hora_sal)}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Home);
